const IconUpload = () => {
  return (
    <svg
      width='50'
      height='50'
      viewBox='0 0 50 50'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='25' cy='25' r='25' fill='#1C6EC9' fillOpacity='0.05' />
      <path
        d='M24.6504 23.1555V28.6411M26.781 25.294L24.6515 23.1555L22.522 25.294'
        stroke='#1C6EC9'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M26.6534 16.6668C27.1698 16.6668 27.6645 16.8768 28.0223 17.2498L31.5324 20.9069C31.8722 21.2602 32.0615 21.7315 32.0615 22.2217V29.7809C32.075 31.6852 30.5772 33.2559 28.6756 33.3334L21.3372 33.3325C19.4177 33.2902 17.8965 31.7004 17.9389 29.7809V20.0525C17.9839 18.1646 19.5313 16.6587 21.4202 16.6668H26.6534Z'
        stroke='#1C6EC9'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M27.1011 16.7246V19.403C27.1002 20.7097 28.1582 21.7713 29.4658 21.774H32.0018'
        stroke='#1C6EC9'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default IconUpload;
